import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { Member, AChatroom} from '../../class/ana-chatroom';
import { ChatroomProvider } from '../../providers/chatroom/chatroom';
import { HttpProvider } from '../../providers/http/http';
import { NavController } from 'ionic-angular/index';
import {UtilProvider} from "../../providers/util/util";
// import {BaseConfigProvider} from "../../providers/base-config/base-config";
// declare var _hmt:any;
/**
 * Generated class for the ExcContactComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'exc-contact',
  templateUrl: 'exc-contact.html',
  host: { '(document:click)': 'hideShowBox($event)' },
})
export class ExcContactComponent implements OnChanges {
  @Input() chatroom: AChatroom;
  @Input() time_scope: number;
  @Output() change_time_scope = new EventEmitter();
  @Output() showMember = new EventEmitter();

  constructor(
    private chatroomService: ChatroomProvider,
    public http: HttpProvider,
    public util:UtilProvider,
    public nav: NavController
  ) {
    // this.choosed_scope = this.scopes[0];
    // if(BaseConfigProvider.isOnline)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['chatroom'] && this.chatroom) {
      // _hmt.push(['_trackPageview', '/excContactPage']);

      this.choosed_scope = this.scopes[this.time_scope];
      this.getExceptionMemberList();
    }
  }

  tab_index = 0;
  chooseTab(index) {
    if (index != this.tab_index) {
      this.tab_index = index;
    }
  }

  is_loading_list: boolean;
  is_error_loading: boolean;
  out_list: Array<Member> = [];
  in_list: Array<Member> = [];
  updata_time;
  getExceptionMemberList() {
    this.updata_time = new Date().getTime();
    this.is_error_loading = false;
    this.is_loading_list = true;
    this.chatroomService
      .getExceptionMemberList(
        // chatroomname 为唯一ID
        this.chatroom.chatroomname,
        this.choosed_scope.value
      )
      .subscribe(
        res => {
          this.is_error_loading = false;
          this.is_loading_list = false;
          this.out_list = res['content']['out_list']
            ? res['content']['out_list'].map(item => new Member(item))
            : [];
          this.in_list = res['content']['in_list']
            ? res['content']['in_list'].map(item => new Member(item))
            : [];
        },
        err => {
          this.is_error_loading = true;
          this.is_loading_list = false;
          // this.http.errCatch(err);
        }
      );
  }

  scopes = [
    { name: '今日', value: 1 },
    {name:'昨天',value:2},

    { name: '7天', value: 3 },
    { name: '30天', value: 4 },
    // { name: '全部', value: 5 },
  ];

  choosed_scope = this.scopes[0];
  changeScope(index){
    // this.hideDropDown();

      this.choosed_scope = this.scopes[index];
      this.change_time_scope.emit(index);
      this.in_list = [];
      this.out_list = [];
      this.getExceptionMemberList();
  }

  show_box_index;
  showBox(e, index) {
    e.stopPropagation();
    this.show_box_index = index;
  }
  hideShowBox(e) {
    this.show_box_index = null;
  }

  is_show: boolean = false;
  showDropDown(e) {
    e.stopPropagation();
    this.is_show = true;
  }

  showMemberDetail(member) {
    // this.nav.push('ContactPage', {
    //   chatroom: JSON.stringify(this.chatroom),
    //   member: JSON.stringify(member),
    //   owner_id: null,
    // });
    this.showMember.emit(member.username);
  }

  // hideDropDown(){
  //   // if(this.is_show && !this.drop_down.nativeElement.contains(e.target)){
  //   this.is_show = false;
  //   // }
  // }

}



// WEBPACK FOOTER //
// ./src/components/exc-contact/exc-contact.ts